import Vue from 'vue'
import axios from 'axios'
import qs from 'qs';
import router from '../../router/index'
import store from '@/store' // vuex库
import {
    getToken
} from './request' // 获取/删除token  
import {
    isFunction
} from 'util';

Vue.prototype.$ajax = axios;

var baseUrl = 'http://117.158.143.236:8090'

if (process.env.NODE_ENV === 'development') { //本地
  
    baseUrl = 'http://117.158.143.236:8090'
   
} else {
    if (process.env.NODE_ENV === 'production') {
        let _host = window.location.host;
        if (_host == 'xcx.biaoruan.wang') {
      
            baseUrl = 'http://117.158.143.236:8090'
        } else {
         
           baseUrl = 'http://117.158.143.236:8090'
        }
    }
} // create an axios instance
sessionStorage.setItem('baseUrl', baseUrl)
const service = axios.create({
    baseURL: baseUrl, // api 的 base_url
    timeout: 30000 // request timeout
})

service.interceptors.request.use(

    config => {
        if (config.method === 'post') {
            config.data = qs.stringify({
                ...config.data
            })
        } else {
            config.params = {
                ...config.params
            };
        }
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        config.headers['x-frame-options'] = "DENY"
        if (sessionStorage.getItem('login')) {
            const tok = JSON.parse(sessionStorage.getItem('login')).token || '';
            const orgId = JSON.parse(sessionStorage.getItem('login')).orgId || '';
            config.headers['token'] = tok;
            config.headers['orgId'] = orgId;
        }
        return config
    },
    error => {
        // Do something with request error
        // console.log(error) // for debug
        // Promise.reject(error)
    }
)
service.interceptors.response.use(
    // response => response,
    res => {
        if (res.data.code == '1006') {
            //console.log('拦截器--登录失效')
            window.location.href = '/'
        } else {
            // console.log(111);/404
            return res
        }
    },
    /**
     * 下面的注释为通过在response里，自定义code来标示请求状态
     * 当code返回如下情况则说明权限有问题，登出并返回到登录页
     * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
     * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
     */
    // response => {
    //   const res = response.data
    //   if (res.code === -2) {
    //     location.reload()
    //   }
    // },
    // response => {
    //   const res = response.data
    //   if (res.code !== 20000) {
    //     Message({
    //       message: res.message,
    //       type: 'error',
    //       duration: 5 * 1000
    //     })
    //     // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
    //     if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //       // 请自行在引入 MessageBox
    //       // import { Message, MessageBox } from 'element-ui'
    //       MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
    //         confirmButtonText: '重新登录',
    //         cancelButtonText: '取消',
    //         type: 'warning'
    //       }).then(() => {
    //         store.dispatch('FedLogOut').then(() => {
    //           location.reload() // 为了重新实例化vue-router对象 避免bug
    //         })
    //       })
    //     }
    //     return Promise.reject('error')
    //   } else {
    //     return response.data
    //   }
    // },
    error => {
        console.log('err' + error) // for debug   路径错误返回404页面
        if (error.message.indexOf(404) !== -1) {
            let url = window.location.href
            let index = url.indexOf('#')
            let newUrl = url.substring(0, index + 2)
            window.location.href = newUrl + '404'
        }
        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/components/servers/reque.js